import { render, staticRenderFns } from "./notify-card.vue?vue&type=template&id=d2af4242&scoped=true&"
import script from "./notify-card.vue?vue&type=script&lang=js&"
export * from "./notify-card.vue?vue&type=script&lang=js&"
import style0 from "./notify-card.vue?vue&type=style&index=0&id=d2af4242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2af4242",
  null
  
)

export default component.exports